<template>
  <vx-card title="Update Qty & Doc #">
    <div class="vx-row align-center">
      <div class="vx-col flex items-center justify-center flex-col  mx-auto ">

        <form>
          <div class="vx-row">
            <div class="vx-col w-full ">
              <vs-input size="large" v-validate="'max:5|numeric'"
                :label="subject == 'gr' ? 'Quantity Received' : 'Quantity Sent Out'" name="qtyReceived" v-model="data.qty"
                class="mt-5 input-center w-full" max="5" />
              <span class="text-danger text-sm" v-show="errors.has('qtyReceived')">{{
                errors.first('qtyReceived')
              }}</span>
            </div>

            <div class="vx-col w-full">
              <vs-input size="large" v-validate="'max:50'" :label="subject == 'gr' ? 'Supplier Doc #' : 'SQL Doc. No.:'"
                name="doc" v-model="data.supplierDocNumber" class="mt-5 input-center w-full" />
              <span class="text-danger text-sm" v-show="errors.has('doc')">{{
                errors.first('doc')
              }}</span>
            </div>

            <div class="vx-col w-full">
              <vs-input size="large" v-validate="'max:50'" label="Remarks" name="remarks" v-model="data.remarks"
                class="mt-5 input-center w-full" />
              <span class="text-danger text-sm" v-show="errors.has('remarks')">{{
                errors.first('remarks')
              }}</span>
            </div>
          </div>
          <vs-button class="mt-5 w-full" @click="updateGrGsQty()" size="large">SAVE</vs-button>
        </form>

      </div>
    </div>
  </vx-card>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import { alertMixin } from '../../mixin/alertMixin';
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    StatisticsCardLine,
  },
  data() {
    return {
      data: {
        qty: null,
        supplierDocNumber: '',
        remarks: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
    }),
  },
  props: {
    subject: {
      type: String,
      default: false,
    },
    id: {
      type: Number,
      default: '',
    }
  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    updateGrGsQty() {
      this.startLoading();
      this.aronPost('updateGrGsQty', { data: this.data, subject: this.subject, id: this.id, user: this.getUserInfo.name }, '', '')
        .then(response => {
          if (response.status) {
            this.successAlert('Success', response.data.message);
            this.$emit('close');
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          this.decodeErrorFromAxios(error).then((errorMsg) => { });
          this.stopLoading();
        })

    }

  },
  mounted() {
    //  this.getData();
  },
  created() {

  }
};
</script>
<style>
.input-center {
  text-align: center;
}

.input-center input {
  text-align: center;
}
</style>
